import { IntlShape } from 'react-intl';
import { formatTranslation, unsafeTranslationKey } from 'intl';
import { UserOnViewWithIssueAccessLevel } from 'shared/domain/user/types/view';
import { ReactElement } from 'react';
import {
  ListItem,
  Tooltip,
  ListItemIcon,
  Box,
  ListItemText,
  Chip,
  ListItemProps,
  MenuItem,
} from '@mui/material';
import { getAccessLevelIcon } from 'views/issue/issueView/AccessManagement/getIcon';

export function UserSelectOption(props: {
  user: UserOnViewWithIssueAccessLevel;
  intl: IntlShape;
  chipColor: string | null;
}): ReactElement {
  const { user, intl, chipColor, ...rest } = props;
  return (
    <MenuItem
      key={user._id}
      sx={{
        display: 'flex',
        alignItems: 'center',
        py: 1,
        minHeight: '48px',
      }}
      {...rest}
    >
      {user.accessLevel && (
        <Tooltip
          title={formatTranslation(intl, unsafeTranslationKey(user.accessLevel.explanationLabel),)}
        >
          <ListItemIcon sx={{ minWidth: 40 }}>
            {getAccessLevelIcon(user.accessLevel.value, false)}
          </ListItemIcon>
        </Tooltip>
      )}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 1,
          flex: 1,
          minWidth: 0,
        }}
      >
        <ListItemText
          sx={{
            margin: 0,
            flex: '1 1 auto',
            minWidth: '120px',
          }}
        >
          {user.label}
        </ListItemText>
        <Chip
          label={user.email}
          size='small'
          sx={{
            backgroundColor: chipColor,
            maxWidth: '100%',
            flex: '0 1 auto',
          }}
        />
      </Box>
    </MenuItem>
  );
}
